import { render, staticRenderFns } from "./ReturPurchasing.vue?vue&type=template&id=d16da8a2"
import script from "./ReturPurchasing.vue?vue&type=script&lang=js"
export * from "./ReturPurchasing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports